module.exports = __webpack_public_path__ + "fonts/notosans-regular-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Noto_Sans/notosans-regular-webfont.woff
// module id = 3444
// module chunks = 0